import { render } from "./M0.vue?vue&type=template&id=ba2e885c&scoped=true"
import script from "./M0.vue?vue&type=script&lang=js"
export * from "./M0.vue?vue&type=script&lang=js"

import "./M0.vue?vue&type=style&index=0&id=ba2e885c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2e885c"]])

export default __exports__